import { AnimationEvent } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostBinding,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  fromEvent,
  map,
  merge,
  Observable,
  Subject,
  takeUntil,
  throttleTime,
} from 'rxjs';

import { fadeInOut, mouseDown, scaleInOut } from './cursor-animations';

export type CursorState = 'enter' | 'exit';

@Component({
    selector: 'lui-cursor',
    templateUrl: './cursor.component.html',
    animations: [fadeInOut, mouseDown, scaleInOut],
    standalone: false
})
export class CursorComponent implements OnInit, OnDestroy {
  _state: CursorState = 'enter';
  _isMouseDown = false;

  @HostBinding('class') className = 'cursor';

  @HostBinding('style.transform') position!: string;

  @HostBinding('class.visible') visible = false;

  animationStateChanged = new EventEmitter<AnimationEvent>();

  _destroy$ = new Subject<void>();

  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    fromEvent(this.document, 'mousemove')
      .pipe(takeUntil(this._destroy$), throttleTime(5))
      .subscribe((e) => {
        if (e instanceof MouseEvent) {
          if (!this.visible) {
            this.visible = true;
          }
          this.position = `translate(${e.clientX}px, ${e.clientY}px)`;
        }
      });

    this._getIsMouseDownStream()
      .pipe(takeUntil(this._destroy$))
      .subscribe((isMouseDown) => {
        this._isMouseDown = isMouseDown;
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  startExitAnimation() {
    this._state = 'exit';
  }

  private _getIsMouseDownStream(): Observable<boolean> {
    return merge(
      fromEvent(this.document, 'mousedown').pipe(map(() => true)),
      fromEvent(this.document, 'mouseup').pipe(map(() => false))
    );
  }
}
